import { render, staticRenderFns } from "./EnergyFlowDiagram.vue?vue&type=template&id=0cb9bd2e&"
import script from "./EnergyFlowDiagram.vue?vue&type=script&lang=js&"
export * from "./EnergyFlowDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports